import { render, staticRenderFns } from "./directorDelegationBoard.vue?vue&type=template&id=3e721082&"
import script from "./directorDelegationBoard.vue?vue&type=script&lang=js&"
export * from "./directorDelegationBoard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports